import { ENVIRONMENT_INITIALIZER, EnvironmentProviders, Provider, inject } from "@angular/core";
import { ConfirmationDialogService } from "./confirm-dialog.service";

export const provideConfirmDialog = (): Array<Provider | EnvironmentProviders> =>
{
    return [
        {
            provide : ENVIRONMENT_INITIALIZER,
            useValue: () => {
                inject(ConfirmationDialogService)
            },
            multi   : true
        },
    ];
}